export default __webpack_public_path__ + "static/media/Vector (2).5c71e4e7.svg";